module.exports = __webpack_public_path__ + "media/components/Sponsors/Projects/Show/Evaluation/fullStar-76d9fd223c1b14f000eb2bded29d6360.svg";